import { QueueFilter } from "@/components/molecules/queueFilter/QueueFilter";
import { InteractionHistoryFiltersButton } from "./InteractionHistoryFiltersButton";
import { Flex } from "@/components/atoms/flex";
import { HistoryFilterActions } from "@/common/stores/nonpersistingStores/history/types";
import { useHistoryFilterStore } from "@/common/stores/nonpersistingStores/history/historyFilterStore";
import { CacheKey } from "@/common/stores/persistingStores/app";
import { useCallback } from "react";

const InteractionHistoryFilterButtons = () => {
	const historyQueueIdsCacheKey: CacheKey = CacheKey.HistoryQueueIds;

	const historyFilterActions = useHistoryFilterStore(
		(actions: HistoryFilterActions) => actions
	);

    const onSelectedQueuesChanged = useCallback((selectedQueueIds: string[]) => {
        historyFilterActions.setQueueIds(selectedQueueIds);
    }, [historyFilterActions.setQueueIds])

	return (
		<Flex>
			<InteractionHistoryFiltersButton />
			<QueueFilter
				cacheKey={historyQueueIdsCacheKey}
				onSelectedQueuesChange={onSelectedQueuesChanged}
			/>
		</Flex>
	);
};

export default InteractionHistoryFilterButtons;
